import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

// App-wide toasts for order results (replaces window.alert on the trade screen).
const Ctx = createContext(null);

export function ToastProvider({ children }) {
  const [queue, setQueue] = useState([]);
  const push = useCallback((severity, text) => {
    setQueue((q) => [...q, { key: Date.now() + Math.random(), severity, text: String(text).slice(0, 400) }]);
  }, []);
  const api = useMemo(
    () => ({
      success: (t) => push('success', t),
      error: (t) => push('error', t),
      info: (t) => push('info', t)
    }),
    [push]
  );
  const current = queue[0];
  const close = () => setQueue((q) => q.slice(1));
  return (
    <Ctx.Provider value={api}>
      {children}
      <Snackbar
        key={current?.key}
        open={Boolean(current)}
        autoHideDuration={current?.severity === 'error' ? 8000 : 5000}
        onClose={(_, reason) => reason !== 'clickaway' && close()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {current ? (
          <Alert onClose={close} severity={current.severity} variant="filled" className="x-toast">
            {current.text}
          </Alert>
        ) : (
          <span />
        )}
      </Snackbar>
    </Ctx.Provider>
  );
}

const fallback = {
  success: (t) => window.alert(t),
  error: (t) => window.alert(t),
  info: (t) => window.alert(t)
};
export const useToast = () => useContext(Ctx) || fallback;
